import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Terminal"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 3.00757H19.5C20.3284 3.00757 21 3.67914 21 4.50757V19.5076C21 20.336 20.3284 21.0076 19.5 21.0076H4.5C3.67157 21.0076 3 20.336 3 19.5076V4.50757C3 3.67914 3.67157 3.00757 4.5 3.00757ZM8.68482 14.2651L6.56982 12.1426L7.62732 11.0851L10.8073 14.2651L7.62732 17.4451L6.56982 16.3876L8.68482 14.2651ZM19.5 4.50757V7.50757H4.5V4.50757H19.5ZM4.5 9.00757V19.5076H19.5V9.00757H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Terminal.vue"]]);
